export function catchUnhandledDashboardError(message, file, line, col, error) {
    console.warn("Unhandled error:", message, file, line, col, error);
}
